// extracted by css-extract-rspack-plugin
export default {"wrapper":"Application_wrapper_bCzZU"};